import { Trash2, FolderInput, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface BulkActionsBarProps {
  selectedCount: number;
  onDelete: () => void;
  onMoveToFolder: () => void;
  onAddTags: () => void;
  onClearSelection: () => void;
}

export const BulkActionsBar = ({
  selectedCount,
  onDelete,
  onMoveToFolder,
  onAddTags,
  onClearSelection,
}: BulkActionsBarProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-card border shadow-lg rounded-lg p-4 flex items-center gap-4">
        <Badge variant="secondary" className="text-sm">
          {selectedCount} selected
        </Badge>

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onMoveToFolder}
          >
            <FolderInput className="h-4 w-4 mr-2" />
            Move to Folder
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={onAddTags}
          >
            <Tag className="h-4 w-4 mr-2" />
            Add Tags
          </Button>

          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </Button>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={onClearSelection}
        >
          Clear Selection
        </Button>
      </div>
    </div>
  );
};
